import { useState, useEffect, useContext, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { UserContext } from '../../../helper/ProtectedRoute';
import DeleteIcon from '../../../assets/img/delete_icon.svg';
import editicon from '../../../../src/assets/img/editicon.svg';
import { Modal } from 'react-bootstrap';
import BankChargesForm from '../Cod/BankChargesForm';
import { showErrorToast } from '../../../components/Toast/Toaster';
import { useConfigStore } from "../../../store/ConfigMgt/ConfigStore";
import { useCodAutomationStore } from '../../../store/CodAutomation/codAutomationStore';
import DeletingModal from '../../../components/modal/deletingModal';
import dayjs from 'dayjs';

const TableComponent = ({
  tableData,
}) => {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [state] = useContext(UserContext);
  const [role, setRole] = useState(sessionStorage.getItem('user_access_role'));
  useEffect(() => {
    setRole(state.roles);
  }, [state.roles]);

  const countriesData = useConfigStore((state) => state?.countriesData);
  const currencyData = useConfigStore((state) => state?.currencyData);
  const getAllBankCharges = useCodAutomationStore((state) => state?.getAllBankCharges);

  const getData = useCallback(async () => {
    try {
      await getAllBankCharges();
    } catch (error) {
      showErrorToast('Error');
    }
  }, [getAllBankCharges]);

  const onSaveSuccess = useCallback(() => {
    setOpenEditModal(false);
    getData();
  }, [getData]);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteParams, setDeleteParams] = useState({ id: '', name: '', title: '' });
  const [deleteParamsId, setDeleteParamsId] = useState({ idOne: '', idTwo: '', name: '', title: '' });

  const deleteParamsSetter = (id, name, title) => {
    setDeleteParams({ id, name, title });
    setIsDeleteModalOpen(true);
  };

  const colCount = 10;

  return (
    <>
      {openEditModal && createPortal(
        <Modal
          className="addnewpopupRoutes"
          show={openEditModal}
          onHide={() => { setOpenEditModal(false); setSelectedRow(null); }}
          centered
        >
          <Modal.Header closeButton>
            <h4 className="fontSize16 blackText fontWeight500">Edit Bank Charges</h4>
          </Modal.Header>
          <Modal.Body>
            <BankChargesForm
              row={selectedRow}
              countriesData={countriesData}
              currencyData={currencyData}
              onSaveSuccess={onSaveSuccess}
              onCancel={() => setOpenEditModal(false)}
            />
          </Modal.Body>
        </Modal>,
        document.body
      )}
      {isDeleteModalOpen && deleteParams?.title && createPortal(
        <DeletingModal
          deleteHandler={isDeleteModalOpen}
          setDeleteHandler={setIsDeleteModalOpen}
          deleteParams={deleteParams}
          setDeleteParams={setDeleteParams}
          deleteParamsId={deleteParamsId}
          setDeleteParamsId={setDeleteParamsId}
        />,
        document.body
      )}
      <thead className="bg-gray-50 border-b border-gray-200">
        <tr>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">#</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Country Code</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Bank Name</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Currency</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Created At</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Created By</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Updated At</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Updated By</th>
          <th className="tbl-th sticky top-0 right-0 z-20 bg-gray-50 text-center">Actions</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {!tableData?.length ? (
          <tr>
            <td colSpan={colCount} className="px-6 py-12 text-center text-gray-500">No records found</td>
          </tr>
        ) : (
          tableData.map((item, index) => (
            <tr
              key={item?.id}
              className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}
            >
              <td className="tbl-td">{index + 1}</td>
              <td className="tbl-td">{item?.countryCode}</td>
              <td className="tbl-td">{item?.bankName}</td>
              <td className="tbl-td">{item?.currency}</td>
              <td className="tbl-td">{item?.charges}</td>
              <td className="tbl-td">
                {item?.createdAt ? dayjs(item?.createdAt).format('DD MMM YYYY, hh:mm:ss A') : null}
              </td>
              <td className="tbl-td">{item?.createdBy}</td>
              <td className="tbl-td">
                {item?.updatedAt ? dayjs(item?.updatedAt).format('DD MMM YYYY, hh:mm:ss A') : null}
              </td>
              <td className="tbl-td">{item?.updatedBy}</td>
              <td className="tbl-td sticky right-0 z-10 bg-white">
                <div className="flex items-center justify-center gap-1">
                  <button
                    className="p-1.5 bg-white hover:!bg-gray-100 rounded transition-colors"
                    title="Edit"
                    onClick={() => { setOpenEditModal(true); setSelectedRow(item); }}
                  >
                    <img src={editicon} className="h-4 w-4 turnBlack" alt="edit" />
                  </button>
                  <button
                    className="p-1.5 bg-white hover:!bg-gray-100 rounded transition-colors"
                    title="Delete"
                    onClick={() => deleteParamsSetter(item?.currency, item?.currency, 'Bank Charges')}
                  >
                    <img src={DeleteIcon} className="h-4 w-4 turnBlack" alt="delete" />
                  </button>
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </>
  );
};

export default TableComponent;
